module.exports = __webpack_public_path__ + "static/media/hw_i_2.6c8bb20f.flv";